<template>
  <div id="OrganManage">
    <!-- 加载工作环节-机构人员管理插件内容, 插件采用默认值不需传递环节ID参数 -->
    <organuser SplitProcessID="00000000"></organuser>
  </div>
</template>

<script>
export default {
  name: "OrganManage",
  data() {
    return {
      active: 0
    };
  },
  components: {
    organuser: (
      resovle //机构人员审核
    ) => require(["@/exam-plugin/process/components/organuser.vue"], resovle),
  },
  methods: {},
  created() {}
};
</script>

<style scoped>
</style>